import { spacer16 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { cssSpacing } from "../../styles";
import { Type } from "../Type";
export var TitleText = styled(Type).withConfig({
  displayName: "TitleText",
  componentId: "sc-1t77w68-0"
})(["min-inline-size:0;overflow-wrap:break-word;margin-inline-end:", ";"], cssSpacing('base', spacer16));